import { render, staticRenderFns } from "./AllotmentHistory.vue?vue&type=template&id=46756be8"
import script from "./AllotmentHistory.vue?vue&type=script&lang=js"
export * from "./AllotmentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports